import React, { useEffect, useMemo, useState } from "react";
import OutputCue from "./OutputCue";

function useObjectWatcher(obj) {
	const [trackedObject, setTrackedObject] = useState(obj);
	const initialState = useMemo(() => JSON.stringify(obj), [obj]);

	useEffect(() => {
		setTrackedObject(obj);
	}, [obj]);

	const hasChanged = useMemo(() => {
		const currentState = JSON.stringify(trackedObject);
		return initialState !== currentState;
	}, [trackedObject, initialState]);

	return { trackedObject, setTrackedObject, hasChanged };
}

export default function OutputCueTransition({ cue, cloud, forceMute = false }) {
	// const [myObject, setMyObject] = useState({ a: 1, b: 2 });
	const { trackedObject, setTrackedObject } = useObjectWatcher(cue);

	const cueMemo = useMemo(
		() => <OutputCue cue={trackedObject} cloud={cloud} forceMute={forceMute} />,
		[trackedObject, cloud, forceMute]
	);

	useEffect(() => {
		setTrackedObject(cue);
	}, [cue, setTrackedObject]);

	if (["offair", "ready"].includes(cue.status) && !['map', 'webpage'].includes(cue.type)) return null;

	return cueMemo;
}
